import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/banner/privacidad.jpg');

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title={t('pages.legal.accesibilidad.bannerTitle')} pagename={t('pages.legal.accesibilidad.bannerPagename')} description={t('pages.legal.accesibilidad.bannerDescription')} bgimage={bnrimg} />

                <div className="section-full p-t80 p-b50 mobile-page-padding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="service-single-block m-b30">
                                    <h3 className="m-b20">{t('pages.legal.accesibilidad.title')}</h3>
                                    <p>{t('pages.legal.accesibilidad.intro')}</p>

                                    <h4>{t('pages.legal.accesibilidad.collection.heading')}</h4>
                                    <p>{t('pages.legal.accesibilidad.collection.body1')}</p>
                                    <p>{t('pages.legal.accesibilidad.collection.body2')}</p>
                                    <p>{t('pages.legal.accesibilidad.collection.body3')}</p>

                                    <h4>{t('pages.legal.accesibilidad.userRights.heading')}</h4>
                                    <p>{t('pages.legal.accesibilidad.userRights.body')}</p>

                                    <h4>{t('pages.legal.accesibilidad.disclosure.heading')}</h4>
                                    <p>{t('pages.legal.accesibilidad.disclosure.body')}</p>

                                    <h4>{t('pages.legal.accesibilidad.security.heading')}</h4>
                                    <p>{t('pages.legal.accesibilidad.security.body')}</p>

                                    <h4>{t('pages.legal.accesibilidad.compliance.heading')}</h4>
                                    <p>{t('pages.legal.accesibilidad.compliance.body')}</p>

                                    <h4>{t('pages.legal.accesibilidad.contact.heading')}</h4>
                                    <p>{t('pages.legal.accesibilidad.contact.body')}</p>

                                    <p><strong>{t('pages.legal.accesibilidad.establishedLabel')}</strong> {t('pages.legal.accesibilidad.establishedValue')}</p>
                                    <p><strong>{t('pages.legal.accesibilidad.lastRevisionLabel')}</strong> {t('pages.legal.accesibilidad.lastRevisionValue')}</p>
                                    <p><strong>SoltArc Services</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
